import { ERROR_USER_LOCKED, ERROR_USER_DELETED, ERROR_SERVICE_NOT_AVAILABLE, ERROR_USER_IN_REGISTRATION } from './../../error/errorMessage';
import { IAppState } from './../../appState/app.state';
import { Store } from '@ngrx/store';
import { UserModel } from './../../shared/model/userModel';
import { Router } from '@angular/router';
import { Component, OnInit, Inject, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { SessionService } from '../../session/session.service';
import { AbstractSessionService } from '../../session/abstract-session.service';
import { ErrorAction } from '../../appState/app.actions';
import { AppState } from '../../appState/appStateStore.module';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  model: UserModel = new UserModel();
  loading = false;
  error = '';
  questionText = '';
  showPin = false;
  hide = true;

  constructor(private router: Router, private sessionService: AbstractSessionService,
    private store: Store<AppState>) { }

  ngOnInit() { }

  anmelden(event) {
    this.loading = true;
    this.sessionService.login(this.model)
      .subscribe(result => {
        if (result !== true) {
          this.loginFailed(undefined);
          return;
        }

        this.sessionService.getSession().then(session => {
          if (session.pinRequired) {
            this.showPin = true;
            this.loading = false;
          } else if (session.passwordNeedsChange.PasswordNeedsChange) {
            this.router.navigate(['/changepassword']);
          } else {
            this.router.navigate(['/kvNummerSuche']);
          }
        })
          .catch(err => {
            this.loginFailed(err);
          });
      },
        (err) => this.loginFailed(err)
      );
  }

  loginFailed(resultError) {
    let errMessage = '';
    if (resultError && resultError.error && resultError.error.Message) {
      errMessage = resultError.error.Message;
    } else if (resultError && resultError.status === 401 && resultError.statusText) {
      errMessage = resultError.statusText;
    } else if (resultError && resultError.message.indexOf('(unknown url)') >= 0) {
      this.store.dispatch(new ErrorAction(ERROR_SERVICE_NOT_AVAILABLE));
      this.router.navigate(['/error']);
    }

    if (errMessage.indexOf('gesperrt') >= 0) {
      this.store.dispatch(new ErrorAction(ERROR_USER_LOCKED));
      this.router.navigate(['/error']);
    }

    if (errMessage.indexOf('Benutzer wurde gelöscht') >= 0) {
      this.store.dispatch(new ErrorAction(ERROR_USER_DELETED));
      this.router.navigate(['/error']);
    }

    if (errMessage.indexOf('Registrierungsprozess') >= 0) {
      this.store.dispatch(new ErrorAction(ERROR_USER_IN_REGISTRATION));
      this.router.navigate(['/error']);
    }

    this.checkIfQuestionRequired();

    if (resultError && resultError.status === 401) {
      this.error = resultError.statusText;
    } else {
      this.error = 'Unbekannter Fehler bei Anmeldung!';
    }

    this.loading = false;
    this.model.pin = '';
  }

  onPasswordLost() {
    //this.store.dispatch( new ErrorAction( ERROR_PASSWORD_LOST));
    this.router.navigate(['/resetaccount']);
    return false; // damit href="#" funktioniert
  }

  onStartRegistration() {
    this.router.navigate(['/register']);
    return false; // damit href="#" funktioniert
  }

  clearError() {
    this.error = null;
  }

  checkIfQuestionRequired() {
    if (   this.model.username !== null
        && this.model.username !== undefined
        && this.model.username.length > 0) {
      this.questionText = '';
      this.model.questionAnswer = '';
      this.model.questionToken = '';

      this.sessionService.getQuestion(this.model.username).subscribe(q => {
        this.questionText = q.QuestionText;
        this.model.questionToken = q.Token;
      });
    }
  }

  onShowPin(pinElement) {
    pinElement.focus();
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/account/login/login.component.ts